import { Component } from '@angular/core';
import { SOLUTION_PAGE_CONFIGS } from 'src/app/shared/components/solution-page/solution-page.config';

@Component({
  selector: 'app-solution1',
  templateUrl: './solution1.component.html',
  styleUrls: ['./solution1.component.scss'],
})
export class Solution1Component {
  readonly pageConfig = SOLUTION_PAGE_CONFIGS[1];
}
